(function () {
  if (!window.autoAddConfig) return;

  const { triggerHandle, giftHandle } = window.autoAddConfig;
  if (!triggerHandle || !giftHandle) return;

  let giftVariantId = null;
  let isProcessing = false;
  let lastSyncTime = 0;
  const SYNC_COOLDOWN = 3000; // 3 secondes minimum entre deux syncs

  async function initGiftVariantId() {
    try {
        const res = await fetch(`/products/${giftHandle}.js`);
        const product = await res.json();
        giftVariantId = product.variants[0].id;
    } catch (e) {
        console.error('Auto-add: impossible de charger le produit offert', e);
    }
  }

  async function syncCart() {
    const now = Date.now();
    if (isProcessing || !giftVariantId) return;
    if (now - lastSyncTime < SYNC_COOLDOWN) return; // Cooldown anti-boucle

    isProcessing = true;
    lastSyncTime = now;

    try {
      const res = await fetch(`/cart.js`);
      const cart = await res.json();
      const items = cart.items;

      const hasTrigger = items.some(item => item.handle === triggerHandle);
      const hasGift = items.some(item => item.variant_id === giftVariantId);

      if (hasTrigger && !hasGift) {
        await silentAdd(giftVariantId);
      } else if (!hasTrigger && hasGift) {
        await silentRemove(giftVariantId);
      }
    } catch (e) {
      console.error('Auto-add: erreur syncCart', e);
    } finally {
      isProcessing = false;
    }
  }

  async function silentAdd(variantId) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    });
    
    if (!res.ok) {
      const data = await res.json();
      console.error('Auto-add: erreur ajout produit offert', res.status, data.description);
      return;
    }

    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
  }

  async function silentRemove(variantId) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 0 }),
    });
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
  }

  function init() {
    // Intercepte les clics sur "Ajouter au panier" sur toute la page
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-add-to-cart], [name="add"], .btn-add-to-cart, product-form button[type="submit"]');
      if (btn && !isProcessing) {
        setTimeout(syncCart, 1500); // Laisse le temps à Shopify de traiter l'ajout
      }
    });

    // Intercepte les suppressions via cart-remove-item (custom element du thème)
    document.addEventListener('click', (e) => {
      const removeBtn = e.target.closest('a[is="cart-remove-item"], [data-index]');
      if (removeBtn && !isProcessing) {
        setTimeout(syncCart, 1500);
      }
    });

    // Intercepte les changements de quantité
    document.addEventListener('change', (e) => {
      const quantityInput = e.target.closest('quantity-input input, [data-quantity-input]');
      if (quantityInput && !isProcessing) {
        setTimeout(syncCart, 1500);
      }
    });

    // Sync initiale au chargement de la page
    initGiftVariantId().then(() => syncCart());
  }

  if (window.FoxTheme?.pubsub) {
    init();
  } else {
    const interval = setInterval(() => {
      if (window.FoxTheme?.pubsub) {
        clearInterval(interval);
        init();
      }
    }, 50);
  }

})();